export default __webpack_public_path__ + "static/media/JeremiahGarcia.75ff4130.png";